<script>
import IconBase from "@/components/IconBase.vue";
import Blank from "@/components/icons/Blank.vue";

export default {
  name: "NewGraduate",
  components: {Blank, IconBase},
  data(){
    return {
      list: [
        { path: '/product/', title: '事業と製品紹介', image: require('../assets/img/newgraduate/01.jpg') },
        { path: '/office/', title: '事業所紹介', image: require('../assets/img/newgraduate/02.jpg') },
        { path: '/keyword/', title: 'クレハがわかる！\n' + '7のキーワード', image: require('../assets/img/newgraduate/03.jpg') },
        { path: 'https://www.kureha-saiyou.com/office/', title: '各事業所近辺情報 ', image: require('../assets/img/newgraduate/07.jpg'), isOpenLink: true },
        { path: '/kureha-quiz-test/', title: 'クレハ検定', subTitle: '〜環境と社会への取り組み編〜',image: require('../assets/img/newgraduate/04.jpg') },
        { path: '/career/', title: 'キャリアステップ ', image: require('../assets/img/newgraduate/05.jpg') },
        { path: '/faq/', title: 'よくあるご質問', image: require('../assets/img/newgraduate/06.jpg') },
        { path: `${process.env.BASE_URL}pdf/Kureha_Job_Hunting_Harassment_Prevention_Policy.pdf`, title: '採用活動における\nハラスメント防止の取り組みについて', isOpenLink: true }
      ]
    }
  }
}
</script>

<template>
<section class="container">
  <div>
    <section class="common_message">
      <h3 class="message_headline">KUREHA Recruiting</h3>
      <p>
        <img
            src="../assets/img/front/nakereba.png"
            alt="ナケレバ、ツクレバ。"
        />
      </p>
      <p class="message">
        それがクレハのこだわり、それがクレハの開発精神。<br />
        独自に開発したモノは、時に形を変え、<br />
        役割を変え、人々の暮らしの中で息づいていく。<br />
        <em>「どこにも無ければ、創ればいい」</em><br />
        世の中が変わっても、その精神は変わらないのです。
      </p>
    </section>
  </div>
  <div class="content">
    <div class="content-header">
      <h4>採⽤情報</h4>
      <figure>
        <img src="../assets/img/common/site_title_noyear.svg"  alt=""/>
      </figure>
    </div>
    <div class="content-list">
      <h5>クレハについて</h5>
      <ul>
        <li v-for="(item, index) in list" :key="index" :class="[{'not-image' : !item.image}]">
          <router-link v-if="!item.isOpenLink" :to="item.path">
            <figure>
              <img :src="item.image" :alt="item.title" />
              <figcaption>{{item.title}} <span v-if="item.subTitle">{{item.subTitle}}</span></figcaption>
            </figure>
          </router-link>
          <a v-else :href="item.path" target="_blank">
            <figure>
              <img v-if="item.image" :src="item.image" :alt="item.title" />
              <figcaption>
                {{item.title}}
                <span v-if="item.subTitle">{{item.subTitle}}
                </span>
                <IconBase :width="14" iconColor="#000" class="icon_base icon--pc" style="margin-left: 4px">
                  <Blank/>
                </IconBase>
                <IconBase :width="12" iconColor="#000" class="icon_base icon--mobile" style="margin-left: 4px; transform: translateY(1px)">
                  <Blank/>
                </IconBase>
              </figcaption>

            </figure>
          </a>
        </li>
      </ul>
    </div>
    <div class="content-main">
      <router-link to="/newgraduate">
        <p>
          <span>新卒採⽤</span> <br class="pc-only" />企画開発職系（総合職）
          <router-link to="/newgraduate">
            <img src="../assets/img/common/circle-arrow-right-white.svg" alt="">
          </router-link>
        </p>
        <picture>
          <source srcset="../assets/img/newgraduate/image_01.jpg"
                  media="(min-width: 901px)">
          <source srcset="../assets/img/newgraduate/image_01sp.jpg"
                  media="(max-width: 900px)">
          <img src="../assets/img/newgraduate/image_01.jpg"  alt="新卒採⽤ 企画開発職系（総合職）" />
        </picture>
        <router-link to="/newgraduate">
          <img src="../assets/img/common/circle-arrow-right-white.svg" alt="">
        </router-link>
      </router-link>
      <a  href="https://www.kureha-saiyou.com/" target="_blank">
        <p>
          <span>新卒採⽤</span>  <br class="pc-only" />実務推進職系（⼀般職）

          <a href="https://www.kureha-saiyou.com/" target="_blank">
            <img src="../assets/img/common/circle-copy.svg" alt="">
          </a>
        </p>
        <picture>
          <source srcset="../assets/img/newgraduate/image_02.jpg"
                  media="(min-width: 901px)">
          <source srcset="../assets/img/newgraduate/image_02sp.jpg"
                  media="(max-width: 900px)">
          <img src="../assets/img/newgraduate/image_02.jpg"  alt="新卒採⽤  実務推進職系(⼀般職)" />
        </picture>
        <a href="https://www.kureha-saiyou.com/" target="_blank">
          <img src="../assets/img/common/circle-copy.svg" alt="">
        </a>
      </a>
      <router-link to="/midcareer">
        <p>
          <span>キャリア採⽤</span>
          <router-link to="/midcareer">
            <img src="../assets/img/common/circle-arrow-right-white.svg" alt="">
          </router-link>
        </p>
        <picture>
          <source srcset="../assets/img/newgraduate/image_03.jpg"
                  media="(min-width: 901px)">
          <source srcset="../assets/img/newgraduate/image_03sp.jpg"
                  media="(max-width: 900px)">
          <img src="../assets/img/newgraduate/image_03.jpg"  alt="新卒採⽤ 企画開発職系（総合職）" />
        </picture>
        <router-link to="/midcareer">
          <img src="../assets/img/common/circle-arrow-right-white.svg" alt="">
        </router-link>
      </router-link>
    </div>
  </div>
</section>
</template>

<style scoped lang="scss">
.container{
  width: 90%;
  margin: 0 auto;
  //padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 72px;
  @media print, screen and (max-width: 900px) {
    //padding: 0 24px;
    grid-template-columns: 1fr;
  }

  & > div{
    &:first-child{
      display: flex;
      justify-content: center;
      padding-bottom: 146px;
      @media print, screen and (max-width: 900px) { padding-bottom: 0; }
      & > .common_message{
        position: sticky;
        top: calc((100vh - 412px) / 2);
        height: fit-content;
        @media print, screen and (max-width: 900px) { position: relative; top: 0; }
      }
    }
  }
}
.content{
  width: 100%;
  padding-top: 112px;
  @media print, screen and (max-width: 900px) {
    padding-top: 62px;
  }
}
.content-header{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 56px;

  @media print, screen and (min-width: 901px) and (max-width: 1128px) {
    column-gap: 28px;
  }

  @media print, screen and (max-width: 900px) {
    flex-direction: column;
  }

  & > h4{
    font-size: 40px;
    font-weight: 700;
    color: #3C3C3C;
    margin: 0;
    white-space: nowrap;
    @media print, screen and (max-width: 900px) {
      font-size: 32px;
    }
  }

  & > figure{
    display: flex;
    max-width: 188px;
    height: auto;
    margin: 8px 0 0 0;
    @media print, screen and (max-width: 900px) {
      max-width: 214px;
      margin: 0;
    }
    & > img {
      width: 100%;
      object-fit: cover;
    }
  }
}

.content-list{
  & > h5{
    font-size: 26px;
    font-weight: 700;
    color: white;
    background-color: #3C3C3C;
    min-height: 56px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    @media print, screen and (max-width: 900px) {
      font-size: 24px;
      min-height: 75px;
    }
  }

  & > ul{
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 24px;
    @media print, screen and (max-width: 900px) {
      column-gap: 24px;
      padding: 0 12px;
    }

    @media print, screen and (min-width: 901px) and (max-width: 1128px) {
      grid-template-columns: 1fr;
    }
    & > li {
      & > a{
        & > figure{
          display: flex;
          align-items: center;
          column-gap: 24px;
          margin: 0;
          @media print, screen and (max-width: 900px) {
            flex-direction: column;
            row-gap: 8px;
          }
          &> img{
            width: 86px;
            height: 86px;
            aspect-ratio: 1;
            border-radius: 12px;
            @media print, screen and (max-width: 900px) {
              width: 100%;
              height: 100%;
              border-radius: 8px;
            }
          }

          & > figcaption{
            color: black;
            font-weight: 700;
            font-size: 16px;
            white-space: pre-line;
            line-height: normal;
            @media print, screen and (min-width: 387px)  and (max-width: 900px) {
              text-align: center;
            }
            @media print, screen and (max-width: 376px) {
              text-align: center;
              font-size: 14px;
            }
            & > span{
              display: block;
              font-size: 12px;
              line-height: normal;
            }
          }
        }
      }
      &:is(.not-image){
        display: flex;
        align-items: center;
        @media print, screen and (max-width: 900px) {
          & > a {
            & > figure {
              & > figcaption {
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
}

.content-main{
  margin: 96px 0 146px 0;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 50px;
  @media print, screen and (max-width: 900px) { row-gap: 70px; }
  & > a{
    &:first-child{
      background: linear-gradient(293.64deg, #3FA800 7.38%, #00797F 93.96%);
    }

    &:nth-child(2){
      background-color: #00A589;
    }

    &:nth-child(3){
      background-color: var(--darkBlue);
    }

    border-radius: 12px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-height: 220px;
    position: relative;
    @media print, screen and (max-width: 900px) {
      min-height: 300px;
      max-height: 100%;
      flex-direction: column;
      align-items: flex-start;
    }
    & > p {
      font-weight: 700;
      color: white;
      font-size: 22px;
      line-height: normal;
      margin: 0;
      padding: 40px;
      position: relative;
      & > span{
        font-size: 26px;
      }

      & > a{
        display: none;
        @media print, screen and (max-width: 900px) {
          display: block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 24px;
        }
      }
      @media print, screen and (max-width: 900px) {
        padding: 0 24px;
        min-height: 112px;
        display: flex;
        align-items: start;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        width: 100%;
      }
    }

    & > picture{
      max-width: 45%;
      width: 100%;
      height: 100%;
      @media print, screen and (max-width: 900px) {
        max-width: 100%;
      }
      & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        @media print, screen and (max-width: 900px) { width: 100%; object-fit: cover }
      }
    }

    & > a {
      position: absolute;
      bottom: 4px;
      right: 12px;
      margin: 0;
      display: block;
      @media print, screen and (max-width: 900px) {
        display: none;
      }
      & > img {
        width: 40px;
        height: 40px;
        aspect-ratio: 1;
        @media print, screen and (max-width: 900px) {
          width: 32px;
          height: 32px;
        }

      }
    }
  }
}

.common_message {
  text-align: center;
  @media print, screen and (max-width: 900px) {
    padding: 96px 0 0 0;
  }
  .message_headline {
    color: #00797f;
    font-size: 16px;
    margin-bottom: 0;
  }
  img {
    max-width: 440px;
    width: 100%;
    @media print, screen and (min-width: 901px) {
      margin-top: 30px;
    }

    @media print, screen and (max-width: 900px) {
     max-width: 345px;
    }

  }
  .message {
    font-weight: bold;
    color: #3fae00;
    font-size: 16px;
    letter-spacing: 0.1em;
    @media print, screen and (max-width: 900px) {
      font-size: 12px;
      letter-spacing: 0em;
    }
    em {
      font-size: 28px;
      line-height: 2em;
      @media print, screen and (max-width: 900px) {
        font-size: 18px;
      }
    }
  }
}

.pc-only{
  @media print, screen and (max-width: 900px) {display: none;}
}
.icon--mobile{
  display: none;
  @media print, screen and (max-width: 900px) {
    display: inline;
  }
}

.icon--pc{
  display: inline;
  @media print, screen and (max-width: 900px) {
    display: none;
  }
}
</style>
